"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.notify.done': '谢谢你创造了我。告诉我我可以如何帮助你。',
};
